<template>
  <ts-panel>
    <ts-panel-wrapper>
      <h1 class="tw-mb-0">{{ $t("user.account") }}</h1>
      <small>{{ $t("user.createANewUserToOperateInSystem") }}</small>
      <div class="mb-3 tw-mt-4">
        <label class="mb-2 required">{{ $t("user.employee") }}</label>
        <a-select
          class="tw-w-full"
          show-search
          option-filter-prop="children"
          allowClear
          v-model="model.employee_id"
          :class="{
            'is-invalid': errors.has('employee_id'),
          }"
          :disabled="isEdit"
          @change="onChangeEmployee()"
        >
          <a-select-option
            v-for="(employee, index) in employees"
            :key="index"
            :value="employee.employee_id"
          >
            {{ employee.employee_name_en }} | Branch:
            {{ employee.branch.prefix_code }}
          </a-select-option>
        </a-select>
        <div class="text-danger" v-if="errors.has('employee_id')">
          {{ errors.first("employee_id") }}
        </div>
      </div>
      <div class="mb-3 tw-mt-4">
        <label class="mb-2 required">{{ $t("user.userName") }}</label>
        <input
          v-model.trim="model.user_name"
          type="text"
          class="form-control fs-13px"
          :placeholder="$t('user.userName')"
          :class="{ 'is-invalid': errors.has('user_name') }"
          :disabled="isEdit"
          ref="user_name"
        />
        <div class="invalid-feedback" v-if="errors.has('user_name')">
          {{ errors.first("user_name") }}
        </div>
      </div>
      <!-- <div class="mb-3">
        <label class="mb-2">{{ $t("user.email") }}</label>
        <input
          v-model.trim="model.email"
          type="email"
          class="form-control fs-13px"
          :placeholder="$t('user.emailAddress')"
          :class="{ 'is-invalid': errors.has('email') }"
        />
        <div class="invalid-feedback" v-if="errors.has('email')">
          {{ errors.first("email") }}
        </div>
      </div> -->
      <div v-if="!isEdit">
        <label class="mb-2 required">{{ $t("user.password") }}</label>
        <div class="row gx-3">
          <div class="col-md-6 mb-2 mb-md-0">
            <input
              v-model="model.password"
              type="password"
              class="form-control fs-13px"
              :placeholder="$t('user.password')"
              :class="{ 'is-invalid': errors.has('password') }"
            />
            <div class="invalid-feedback" v-if="errors.has('password')">
              {{ errors.first("password") }}
            </div>
          </div>
          <div class="col-md-6 mb-2 mb-md-0">
            <input
              v-model="model.password_confirmation"
              type="password"
              class="form-control fs-13px"
              :placeholder="$t('user.confirm')"
              :class="{ 'is-invalid': errors.has('password_confirmation') }"
            />
            <div
              class="invalid-feedback"
              v-if="errors.has('password_confirmation')"
            >
              {{ errors.first("password_confirmation") }}
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3">
        <ts-checkbox v-model="model.disable">{{
          $t("user.disable")
        }}</ts-checkbox>
      </div>
    </ts-panel-wrapper>
  </ts-panel>
</template>

<script>
import { Errors } from "form-backend-validation";
import { isEmpty } from "lodash";
import { mapState } from "vuex";

export default {
  name: "userAccount",
  props: ["value", "validate"],
  data() {
    return {
      errors: new Errors(),
      model: {},
    };
  },
  computed: {
    ...mapState("auth/user", ["edit_data", "employees"]),
    isEdit() {
      return !isEmpty(this.edit_data);
    },
  },
  created() {
    this.model = this.value;
  },
  methods: {
    onChangeEmployee() {
      if (this.model.employee_id) {
        let employee = this.employees.find(
          (p) => p.employee_id == this.model.employee_id
        );
        this.model.user_name = employee.employee_name_en
          .split(" ")
          .join(".")
          .toLowerCase();
      } else {
        this.model.user_name = "";
      }
      this.$nextTick(function () {
        this.$refs.user_name.focus();
      });
    },
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors);
    },
  },
};
</script>
